import axios from "axios";

const getBaseUrl = () => {
  // Проверяем, где запущен код: локально или на Vercel
  if (window.location.hostname === "localhost") {
    return "http://localhost:8000/api";
  }
  return "/api";
};

const api = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Логирование для отладки в консоли браузера (F12)
api.interceptors.request.use((config) => {
  console.log(`🚀 Request to: ${config.baseURL}${config.url}`);
  return config;
});

export const calculationsAPI = {
  calculateTransfer: async (data) => {
    // Итоговый путь: /api/v1/calculations/transfer
    const response = await api.post("/v1/calculations/transfer", data);
    return response.data;
  },

  getRecentCalculations: async (limit = 10) => {
    const response = await api.get(`/v1/calculations/recent?limit=${limit}`);
    return response.data;
  },
};

export default api;